<template>

  <div class="ship_wrap" :style="ship_style" v-if="!need_listen_scroll">
    <slot></slot>
    <div v-if="is_edit" class="name" :style="name_style">{{name}}</div>
  </div>

  <div v-else
       :class="['ship_wrap ship_listen_scroll']"
       :style="ship_style"
       v-show="fixed_show"
  >
    <slot></slot>
    <div v-if="is_edit" class="name" :style="name_style">{{name}}</div>
  </div>
</template>

<script>
  import {isArray} from '../../tools/typeof'
  import {on} from '../../tools/dom'
  import {removeUnit} from '../../tools/unit'
  import throttle from 'lodash/throttle'

  export default {
    name: 'Ship',
    props: {
      name: {
        type: String,
        default: '组件'
      },
      pos: {
        type: String,
        default: 'absolute'
      },
      top: {
        type: String,
        default: '0rem'
      },
      left: {
        type: String,
        default: '0rem'
      },
      scroll_y_range: {
        type: Array,
        default: function () {
          return null
        }
      },
      zIndex: {
        type: [Number,String],
        default: 0
      },
      rotate: {
        type: [Number, String],
        default: 0
      },
      fixed_bottom: {
        type: Boolean,
        default: false
      },
      click_through:{ //点击穿透，目前图片有这个属性
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        fixed_show: true,
      }
    },
    computed: {
      edit() {
        return !!gact.edit
      },
      ship_style() {
        let zIndex = this.zIndex || '0';
        let left = this.left || '0';
        //fixed_bottom 固定在底部
        if (this.pos === 'fixed' || this.fixed_bottom) {
          zIndex += 100; //让fixed元素在上面
            //如果屏幕宽度大于页面宽度，对所有left做一个偏移。left都是已经rem化了的。
            if(this.left.indexOf('rem') !== -1){
              // //计算一个fixed元素的左偏移量，因为fixed元素以body为参照，而不以app为参照
              left = removeUnit(this.left,'rem') + window.g_fixed_left + 'rem'
            }
       }

        let style = {};
        if (!this.fixed_bottom) {
          style = {
            position: this.pos,
            top: this.top,
            left: left,
            zIndex
          };
        } else {
          style = {
            position: 'fixed',
            bottom: 0,
            left: left,
            zIndex
          }
        }


        if (this.rotate) {
          console.log('rotate', this.rotate)
          style.transform = `rotate(${this.rotate}deg)`
          style.webkitTransform = `rotate(${this.rotate}deg)`
        }

        if(this.click_through){
          style.pointerEvents = 'none'

        }

        if (!this.edit) {
          return style;
        }
        ;

        const edit_style = {
          border: `1px solid ${this.edit_color}`,
          background: 'rgba(0,0,0,0.1)'
        };

        return Object.assign(style, edit_style);
      },
      name_style() {
        return {
          background: `${this.edit_color} !important`
        }
      },
      edit_color() {
        return gact.edit_color
      },
      need_listen_scroll() {
        if (!this.pos) {
          return false;
        }
        return this.pos === 'fixed' && this.scroll_y_range;
      },
      is_edit() {
        return gact.edit
      },
    },
    methods: {
      in_scroll_range(_scrollY) {
        const scrollY = _scrollY / 100 * window.g_html_font_size;
        if (isArray(this.scroll_y_range) && this.scroll_y_range.length === 2) {
          if (scrollY >= this.scroll_y_range[0] && scrollY <= this.scroll_y_range[1]) {
            return true
          } else {
            return false;
          }
        } else {
          return true
        }
      }
    },
    mounted() {
      if (this.need_listen_scroll) {

        this.fixed_show = this.in_scroll_range(window.scrollY);

        on(window, 'scroll', throttle(() => {
          const fixed_show = this.in_scroll_range(window.scrollY);
          if (this.fixed_show !== fixed_show) {
            this.fixed_show = fixed_show;
          }
        }, 300));
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import "../../share/mixins.styl"
  .ship_wrap
    position relative
    .name
      position absolute
      top -.4rem
      left 0
      color white
      max-width 100%
      height .4rem
      line-height .4rem
      border-radius 10%
      overflow hidden
      white-space nowrap
      font-size .12rem
      padding 0 2px


</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/Ship.vue